import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provinceFeatureKey, provinceReducer } from './state/province.reducer';
import { ProvinceEffects } from './state/province.effects';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(provinceFeatureKey, provinceReducer),
    EffectsModule.forFeature([ProvinceEffects])
  ]
})
export class ProvinceModule { }
